<!-- @veltra/icons generated sha256:9288e61b15c0d805 gen:8 source:src/svg/colorful/txt.svg -->
<script setup lang="ts">
defineOptions({ name: 'Txt' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#4fd397"
        d="M10.308 1.003H4.225c-1.22 0-2.208.989-2.208 2.208v9.578c0 1.22.988 2.208 2.208 2.208h7.586c1.22 0 2.208-.989 2.208-2.208V4.714c0-.497-.198-.974-.55-1.326l-1.835-1.836a1.88 1.88 0 0 0-1.326-.549"
      />
      <path
        fill="#19bc6e"
        d="m13.47 3.388-1.836-1.836a1.9 1.9 0 0 0-.965-.514v2.06c0 .655.53 1.185 1.185 1.185h2.115a1.9 1.9 0 0 0-.5-.895m-2.997 2.579h-2.38a.4.4 0 0 0-.15 0h-2.38a.375.375 0 0 0 0 .75h2.08v4.043a.375.375 0 0 0 .75 0V6.717h2.08a.375.375 0 0 0 0-.75"
      />
      <path
        fill="#fff"
        d="M10.473 5.78h-2.38a.4.4 0 0 0-.15 0h-2.38a.375.375 0 0 0 0 .75h2.08v4.042a.375.375 0 0 0 .75 0V6.529h2.08a.375.375 0 0 0 0-.75"
      />
    </g>
  </svg>
</template>
